import { render } from "./DetailSection.vue?vue&type=template&id=c634db70&scoped=true"
import script from "./DetailSection.vue?vue&type=script&lang=js"
export * from "./DetailSection.vue?vue&type=script&lang=js"

import "./DetailSection.vue?vue&type=style&index=0&id=c634db70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c634db70"]])

export default __exports__